import { Directive } from '@angular/core';

@Directive({
  selector: '[nttLeading]',
})
export class NttLeading {}
